import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollectionFilterPipe } from './collection-filter.pipe';
import { ConcatValuesPipe } from './concat-values.pipe';
import { FileSizePipe } from './file-size.pipe';
import { ReadableTaskStagePipe } from './readable-task-stage.pipe';
import { SortPipe } from './sort.pipe';
import { UserTitlePipe } from './user-title.pipe';
import { FullNamePipe } from './full-name.pipe';
import { ReadableTurnAroundTimePipe } from './readable-turn-around-time.pipe';
import { IncludesPipe } from './includes.pipe';
import { ReadableExclusionPipe } from './readable-exclusion.pipe';
import { UniqueIdPipe } from './unique-id.pipe';
import { FilterPipe } from './filter.pipe';
import { FileKeyPipe } from './file-key.pipe';
import { SortByPipe } from './sort-by.pipe';
import { GetNotePipe } from './get-note.pipe';
import { FileExtensionPipe } from './file-extension.pipe';
import { MapPipe } from './map.pipe';
import { ReadableDeliveryStatusPipe } from './readable-delivery-status.pipe';
import { CaseServiceByGroupPipe } from './case-service-by-group.pipe';
import { BillingByServiceGroupPipe } from './billing-by-service-group.pipe';
import { ActiveUserOnlyPipe } from './active-user-only.pipe';
import { RemoveSelectedAssigneePipe } from './remove-selected-assignee.pipe';
import { DisabledWhenServiceSelectedPipe } from './disabled-when-service-selected.pipe';
import { ServiceAddonPipe } from './service-addon.pipe';
import { TemplateFieldByGroupPipe } from './template-field-by-group.pipe';
import { ReadableTemplateFieldDataTypePipe } from './readable-template-field-data-type.pipe';
import { GroupsWithFieldsOnlyPipe } from './groups-with-fields-only.pipe';
import { ReadablePaginatedServicePipe } from './readable-paginated-service.pipe';
import { CaseNavigationPipe } from './case-navigation.pipe';
import { CaseServiceNavigationPipe } from './case-service-navigation.pipe';
import { HasOneValidControlPipe } from './has-one-valid-control.pipe';
import { ReadableShortTurnAroundTimePipe } from './readable-short-turn-around-time.pipe';
import { MainServicesOnlyPipe } from './main-services-only.pipe';
import { UniqByPipe } from './uniq-by.pipe';
import { IsInterviewPipe } from './is-interview.pipe';
import { ReadableBillingStatusPipe } from './readable-billing-status.pipe';
import { ReadablePrintAdSizePipe } from './readable-print-ad-size.pipe';
import { ReadableMediaTypePipe } from './readable-media-type.pipe';
import { FindPipe } from './find.pipe';
import { ReadableAdsCaseStatusPipe } from './readable-ads-case-status.pipe';
import { StringifyGroupPipe } from './stringify-group.pipe';
import { ReadableAdSpotPipe } from './readable-ad-spot.pipe';
import { ReadableAdTimeslotPipe } from './readable-ad-timeslot.pipe';
import { ReadableAdSizePipe } from './readable-ad-size.pipe';
import { ReadableAdRunDurationPipe } from './readable-ad-run-duration.pipe';
import { ReadableAdsReferenceNumberTypePipe } from './readable-ads-reference-number-type.pipe';
import { ReadableOnHoldStatusPipe } from './readable-on-hold-status.pipe';
import { ReadableAdsCaseStatusCompanyPipe } from './readable-ads-case-status-company.pipe';
import { UrlPipe } from './url.pipe';
import { FilterUniqueOptionsPipe } from './filter-unique-options.pipe';
import { AdCaseNavigationPipe } from './ad-case-navigation.pipe';
import { AdCaseServiceNavigationPipe } from './ad-case-service-navigation.pipe';
import { ActiveTeamOnlyPipe } from './active-team-only.pipe';
import { ReadableMonthNumberPipe } from './readable-month-number.pipe';
import { NoteSubjectLabelPipe } from './note-subject-label.pipe';
import { ReadableRateTypePipe } from './readable-rate-type.pipe';
import { ShowOnlineEndDatePipe } from './show-online-end-date.pipe';
import { ReadablePermissionPipe } from './readable-permission.pipe';
import { FileErrorBorderPipe } from './file-error-border.pipe';
import { ReadableCompanyTypePipe } from './readable-company-type.pipe';
import { AdCaseServiceIconPipe } from './ad-case-service-icon.pipe';
import { TruncateTextPipe } from './truncate-text.pipe';
import { DateOnlyPipe } from './date-only.pipe';
import { DateTimePipe } from './date-time.pipe';
import { DateOnlyEstPipe } from './date-only-est.pipe';
import { ReadableAdsCaseTypePipe } from './readable-ads-case-type.pipe';
import { ServiceTypeFilterPipe } from './service-type-filter.pipe';
import { ReadableManagerTypePipe } from './readable-manager-type.pipe';
import { ClientAdsCaseNavigateLinkPipe } from './client-ads-case-navigate-link.pipe';
import { ReadableManagerTypesPipe } from './readable-manager-types.pipe';
import { ReadableAdSwaRunDurationPipe } from './readable-ad-swa-run-duration.pipe';
import { ReadableQuoteErrorPipe } from './readable-quote-error.pipe';
import { SortQuoteErrorTypesPipe } from './sort-quote-error-types.pipe';
import { ReadableAdsServicePipe } from './readable-ads-service.pipe';
import { IntersectionPipe } from './intersection.pipe';
import { ReadableExpertCaseFrequencyPipe } from './readable-expert-case-frequency.pipe';
import { ReadableBillingTypePipe } from './readable-billing-type.pipe';
import { ReadableExpertPaymentTypePipe } from './readable-expert-payment-type.pipe';
import { ReadableServiceTierPipe } from './readable-service-tier.pipe';
import { ReadableCompanyPaymentTypePipe } from './readable-payment-type.pipe';
import { ReadableServiceGroupPipe } from './readable-service-group.pipe';
import { ReadableAccreditationStatusPipe } from './readable-accreditation-status.pipe';
import { ReadableObtainedCredentialFlagPipe } from './readable-obtained-credential-flag.pipe';
import { SortByStringPipe } from './sort-by-string.pipe';
import { ReadableExperienceDurationTypePipe } from './readable-experience-duration-type.pipe';
import { ReadableQuoteTypePipe } from './readable-quote-type.pipe';
import { ReadableEdgeSsPreferenceTypePipe } from './readable-edge-ss-preference-type.pipe';
import { ReadableDivisionTypePipe } from './readable-division-type';
import { ReadableVisatypePipe } from './readable-visatype.pipe';
import { ReadableManagerialDefinitionPipe } from './readable-managerial-definition.pipe';
import { ReadableH1bLetterFeaturePipe } from './readable-h1b-letter-feature.pipe';
import { ReadableExtraordinaryAbilityFeaturePipe } from './readable-extraordinary-ability-feature.pipe';
import { ReadableTnLetterFeaturePipe } from './readable-tn-letter-feature.pipe';
import { ReadablePermLetterFeaturePipe } from './readable-perm-letter-feature.pipe';
import { ReadableCandidateQualificationTypePipe } from './readable-candidate-qualification-type.pipe';
import { EvalServicePmToClientPipe } from './eval-service-pm-to-client.pipe';
import { CaseNavigationClientPipe } from './case-navigation-client.pipe';
import { EvalClientStageStatusPipe } from './eval-client-stage-status.pipe';
import { PrelimNavigationPipe } from './prelim-navigation.pipe';
import { ReadablePreliminaryAssessmentStatusPipe } from './readable-preliminary-assessment-status.pipe';
import { HasPrelimActionPipe } from './has-prelim-action.pipe';
import { ReadableClientServiceTypePipe } from './readable-client-service-type.pipe';
import { IntakeAddonComponentPipe } from './intake-addon-component.pipe';

@NgModule({
  declarations: [
    CollectionFilterPipe,
    ConcatValuesPipe,
    FileSizePipe,
    SortPipe,
    UserTitlePipe,
    FullNamePipe,
    ReadableTurnAroundTimePipe,
    IncludesPipe,
    ReadableExclusionPipe,
    ReadableTaskStagePipe,
    UniqueIdPipe,
    FilterPipe,
    FileKeyPipe,
    SortByPipe,
    GetNotePipe,
    FileExtensionPipe,
    MapPipe,
    ReadableDeliveryStatusPipe,
    CaseServiceByGroupPipe,
    BillingByServiceGroupPipe,
    ActiveUserOnlyPipe,
    RemoveSelectedAssigneePipe,
    DisabledWhenServiceSelectedPipe,
    ServiceAddonPipe,
    TemplateFieldByGroupPipe,
    ReadableTemplateFieldDataTypePipe,
    GroupsWithFieldsOnlyPipe,
    ReadablePaginatedServicePipe,
    CaseNavigationPipe,
    CaseServiceNavigationPipe,
    HasOneValidControlPipe,
    ReadableShortTurnAroundTimePipe,
    MainServicesOnlyPipe,
    UniqByPipe,
    IsInterviewPipe,
    ReadableBillingStatusPipe,
    ReadableMediaTypePipe,
    FindPipe,
    ReadablePrintAdSizePipe,
    ReadableAdsCaseStatusPipe,
    StringifyGroupPipe,
    ReadableAdSpotPipe,
    ReadableAdTimeslotPipe,
    ReadableAdSizePipe,
    ReadableAdRunDurationPipe,
    ReadableAdsReferenceNumberTypePipe,
    ReadableOnHoldStatusPipe,
    ReadableAdsCaseStatusCompanyPipe,
    UrlPipe,
    FilterUniqueOptionsPipe,
    AdCaseNavigationPipe,
    AdCaseServiceNavigationPipe,
    ActiveTeamOnlyPipe,
    ReadableMonthNumberPipe,
    NoteSubjectLabelPipe,
    ReadableRateTypePipe,
    ShowOnlineEndDatePipe,
    ReadablePermissionPipe,
    FileErrorBorderPipe,
    ReadableCompanyTypePipe,
    AdCaseServiceIconPipe,
    TruncateTextPipe,
    DateOnlyPipe,
    DateTimePipe,
    DateOnlyEstPipe,
    ReadableAdsCaseTypePipe,
    ServiceTypeFilterPipe,
    ReadableManagerTypePipe,
    ClientAdsCaseNavigateLinkPipe,
    ReadableManagerTypesPipe,
    ReadableAdSwaRunDurationPipe,
    ReadableQuoteErrorPipe,
    SortQuoteErrorTypesPipe,
    ReadableAdsServicePipe,
    IntersectionPipe,
    ReadableExpertCaseFrequencyPipe,
    ReadableBillingTypePipe,
    ReadableExpertPaymentTypePipe,
    ReadableServiceTierPipe,
    ReadableCompanyPaymentTypePipe,
    ReadableServiceGroupPipe,
    ReadableAccreditationStatusPipe,
    ReadableObtainedCredentialFlagPipe,
    SortByStringPipe,
    ReadableExperienceDurationTypePipe,
    ReadableQuoteTypePipe,
    ReadableEdgeSsPreferenceTypePipe,
    ReadableDivisionTypePipe,
    ReadableVisatypePipe,
    ReadableManagerialDefinitionPipe,
    ReadableH1bLetterFeaturePipe,
    ReadableExtraordinaryAbilityFeaturePipe,
    ReadableTnLetterFeaturePipe,
    ReadablePermLetterFeaturePipe,
    ReadableCandidateQualificationTypePipe,
    EvalServicePmToClientPipe,
    CaseNavigationClientPipe,
    EvalClientStageStatusPipe,
    PrelimNavigationPipe,
    ReadablePreliminaryAssessmentStatusPipe,
    HasPrelimActionPipe,
    ReadableClientServiceTypePipe,
    IntakeAddonComponentPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    CollectionFilterPipe,
    ConcatValuesPipe,
    FileSizePipe,
    SortPipe,
    UserTitlePipe,
    FullNamePipe,
    ReadableTurnAroundTimePipe,
    IncludesPipe,
    ReadableExclusionPipe,
    ReadableTaskStagePipe,
    UniqueIdPipe,
    FilterPipe,
    FileKeyPipe,
    SortByPipe,
    GetNotePipe,
    FileExtensionPipe,
    MapPipe,
    ReadableDeliveryStatusPipe,
    CaseServiceByGroupPipe,
    BillingByServiceGroupPipe,
    ActiveUserOnlyPipe,
    RemoveSelectedAssigneePipe,
    DisabledWhenServiceSelectedPipe,
    ServiceAddonPipe,
    TemplateFieldByGroupPipe,
    ReadableTemplateFieldDataTypePipe,
    GroupsWithFieldsOnlyPipe,
    ReadablePaginatedServicePipe,
    CaseNavigationPipe,
    CaseServiceNavigationPipe,
    HasOneValidControlPipe,
    ReadableShortTurnAroundTimePipe,
    MainServicesOnlyPipe,
    UniqByPipe,
    IsInterviewPipe,
    ReadableBillingStatusPipe,
    ReadableMediaTypePipe,
    FindPipe,
    ReadablePrintAdSizePipe,
    ReadableAdsCaseStatusPipe,
    StringifyGroupPipe,
    ReadableAdSpotPipe,
    ReadableAdTimeslotPipe,
    ReadableAdSizePipe,
    ReadableAdRunDurationPipe,
    ReadableAdsReferenceNumberTypePipe,
    ReadableOnHoldStatusPipe,
    ReadableAdsCaseStatusCompanyPipe,
    UrlPipe,
    FilterUniqueOptionsPipe,
    AdCaseNavigationPipe,
    AdCaseServiceNavigationPipe,
    ActiveTeamOnlyPipe,
    ReadableMonthNumberPipe,
    NoteSubjectLabelPipe,
    ReadableRateTypePipe,
    ShowOnlineEndDatePipe,
    ReadablePermissionPipe,
    FileErrorBorderPipe,
    ReadableCompanyTypePipe,
    AdCaseServiceIconPipe,
    TruncateTextPipe,
    DateOnlyPipe,
    DateTimePipe,
    DateOnlyEstPipe,
    ReadableAdsCaseTypePipe,
    ServiceTypeFilterPipe,
    ReadableManagerTypePipe,
    ClientAdsCaseNavigateLinkPipe,
    ReadableManagerTypesPipe,
    ReadableAdSwaRunDurationPipe,
    ReadableQuoteErrorPipe,
    SortQuoteErrorTypesPipe,
    ReadableAdsServicePipe,
    IntersectionPipe,
    ReadableExpertCaseFrequencyPipe,
    ReadableBillingTypePipe,
    ReadableExpertPaymentTypePipe,
    ReadableServiceTierPipe,
    ReadableCompanyPaymentTypePipe,
    ReadableServiceGroupPipe,
    ReadableAccreditationStatusPipe,
    ReadableObtainedCredentialFlagPipe,
    SortByPipe,
    SortByStringPipe,
    ReadableExperienceDurationTypePipe,
    ReadableQuoteTypePipe,
    ReadableEdgeSsPreferenceTypePipe,
    ReadableDivisionTypePipe,
    ReadableVisatypePipe,
    ReadableManagerialDefinitionPipe,
    ReadableH1bLetterFeaturePipe,
    ReadableExtraordinaryAbilityFeaturePipe,
    ReadableTnLetterFeaturePipe,
    ReadablePermLetterFeaturePipe,
    ReadableCandidateQualificationTypePipe,
    EvalServicePmToClientPipe,
    CaseNavigationClientPipe,
    EvalClientStageStatusPipe,
    PrelimNavigationPipe,
    ReadablePreliminaryAssessmentStatusPipe,
    HasPrelimActionPipe,
    ReadableClientServiceTypePipe,
    IntakeAddonComponentPipe,
  ],
})
export class PipesModule { }
